/**
 * Labstep
 *
 * @module components/Tag/Action/Delete
 * @desc Delete resource location
 */

import { EntityActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import type React from 'react';
import type { ITagActionDeleteProps } from './types';

export const Message: React.FC<{ count: number }> = ({ count }) => (
  <div>
    {'This tag is associated with '}
    <b>{count}</b>
    {
      ' entities. If you want to delete it please remove it from all these entities.'
    }
  </div>
);

export const TagActionDelete: React.FC<ITagActionDeleteProps> = ({
  tag,
}) => <EntityActionDelete entity={tag} />;
